import { InputDigitPasswordDigitStateType, InputDigitPasswordStateType, } from '@kubit/web-ui-components/inputDigitPassword/types';
import { DeviceBreakpointsType } from '@kubit/web-ui-components/types/breakpoints';
import { FONT_WEIGHT } from '../../../foundations/typography';
import { variantStateInputDigitPasswordDigitCommonStyles, variantStatesCommonStyles, } from '../commonStyles';
import { InputDigitPasswordVariantType } from '../variants';
export const getDefaultStyles = (FOUNDATIONS, FONT) => {
    return {
        [InputDigitPasswordVariantType.DEFAULT]: {
            inputDigitPassword: {
                [InputDigitPasswordStateType.DEFAULT]: {
                    ...variantStatesCommonStyles(FOUNDATIONS, FONT),
                },
                [InputDigitPasswordStateType.ACTIVE]: {
                    ...variantStatesCommonStyles(FOUNDATIONS, FONT),
                    inputContainer: {
                        ...variantStatesCommonStyles(FOUNDATIONS, FONT).inputContainer,
                        border_width: FOUNDATIONS.border_100,
                        border_color: FOUNDATIONS.color_comp_forms_input_active_border,
                    },
                    inputHiddenFocusVisibleCustom: {
                        border_width: FOUNDATIONS.border_100,
                        border_color: FOUNDATIONS.color_comp_forms_input_active_border,
                        box_shadow: 'none',
                        outline: 'none',
                        outline_offset: 'unset',
                    },
                },
                [InputDigitPasswordStateType.DISABLED]: {
                    ...variantStatesCommonStyles(FOUNDATIONS, FONT),
                    legend: {
                        ...variantStatesCommonStyles(FOUNDATIONS, FONT).legend,
                        color: FOUNDATIONS.color_accent_disabled_font_100,
                    },
                    tooltipIcon: {
                        ...variantStatesCommonStyles(FOUNDATIONS, FONT).tooltipIcon,
                        color: FOUNDATIONS.color_accent_disabled_icon_100,
                    },
                    inputContainer: {
                        ...variantStatesCommonStyles(FOUNDATIONS, FONT).inputContainer,
                        background_color: FOUNDATIONS.color_accent_disabled_bg_100,
                        border_width: FOUNDATIONS.border_50,
                        border_color: FOUNDATIONS.color_accent_disabled_border_100,
                        cursor: 'default',
                    },
                    inputSeparator: {
                        ...variantStatesCommonStyles(FOUNDATIONS, FONT).inputSeparator,
                        background_color: FOUNDATIONS.color_accent_disabled_icon_100,
                    },
                    passwordIcon: {
                        ...variantStatesCommonStyles(FOUNDATIONS, FONT).passwordIcon,
                        color: FOUNDATIONS.color_accent_disabled_icon_100,
                    },
                    keyboardIcon: {
                        ...variantStatesCommonStyles(FOUNDATIONS, FONT).passwordIcon,
                        color: FOUNDATIONS.color_accent_disabled_icon_100,
                    },
                    helpText: {
                        ...variantStatesCommonStyles(FOUNDATIONS, FONT).helpText,
                        color: FOUNDATIONS.color_accent_disabled_font_100,
                    },
                },
                [InputDigitPasswordStateType.ERROR]: {
                    ...variantStatesCommonStyles(FOUNDATIONS, FONT),
                    inputContainer: {
                        ...variantStatesCommonStyles(FOUNDATIONS, FONT).inputContainer,
                        background_color: FOUNDATIONS.color_comp_forms_input_error_empty_bg,
                        border_width: FOUNDATIONS.border_100,
                        border_color: FOUNDATIONS.color_feedback_error_border_50,
                    },
                },
            },
            inputDigitPasswordDigit: {
                [InputDigitPasswordDigitStateType.EMPTY]: {
                    ...variantStateInputDigitPasswordDigitCommonStyles(FOUNDATIONS, FONT),
                },
                [InputDigitPasswordDigitStateType.PREFILLED]: {
                    ...variantStateInputDigitPasswordDigitCommonStyles(FOUNDATIONS, FONT),
                    digitShape: {
                        ...variantStateInputDigitPasswordDigitCommonStyles(FOUNDATIONS, FONT).digitShape,
                        height: FOUNDATIONS.size_150,
                        width: FOUNDATIONS.size_150,
                        background_color: FOUNDATIONS.color_accent_disabled_icon_50,
                    },
                },
                [InputDigitPasswordDigitStateType.FILLED]: {
                    ...variantStateInputDigitPasswordDigitCommonStyles(FOUNDATIONS, FONT),
                    digitShape: {
                        ...variantStateInputDigitPasswordDigitCommonStyles(FOUNDATIONS, FONT).digitShape,
                        font_size: FONT.font_paragraph_50.DESKTOP.font_size,
                        line_height: FONT.font_paragraph_50.DESKTOP.line_height,
                        color: FOUNDATIONS.color_neutral_font_50,
                        font_weight: FONT_WEIGHT.font_regular,
                        [DeviceBreakpointsType.DESKTOP]: {
                            font_size: FONT.font_paragraph_50.TABLET.font_size,
                            line_height: FONT.font_paragraph_50.TABLET.line_height,
                        },
                        [DeviceBreakpointsType.MOBILE]: {
                            font_size: FONT.font_paragraph_50.MOBILE.font_size,
                            line_height: FONT.font_paragraph_50.MOBILE.line_height,
                        },
                    },
                },
                [InputDigitPasswordDigitStateType.FILLED_HIDE]: {
                    ...variantStateInputDigitPasswordDigitCommonStyles(FOUNDATIONS, FONT),
                    digitShape: {
                        ...variantStateInputDigitPasswordDigitCommonStyles(FOUNDATIONS, FONT).digitShape,
                        height: FOUNDATIONS.size_150,
                        width: FOUNDATIONS.size_150,
                        background_color: FOUNDATIONS.color_neutral_icon_50,
                        border_radius: '50%',
                    },
                },
                [InputDigitPasswordDigitStateType.DISABLED_EMPTY]: {
                    ...variantStateInputDigitPasswordDigitCommonStyles(FOUNDATIONS, FONT),
                    digitInputContainer: {
                        ...variantStateInputDigitPasswordDigitCommonStyles(FOUNDATIONS, FONT)
                            .digitInputContainer,
                        border_color: FOUNDATIONS.color_accent_disabled_border_100,
                    },
                },
                [InputDigitPasswordDigitStateType.DISABLED_FILLED]: {
                    ...variantStateInputDigitPasswordDigitCommonStyles(FOUNDATIONS, FONT),
                    digitInputContainer: {
                        ...variantStateInputDigitPasswordDigitCommonStyles(FOUNDATIONS, FONT)
                            .digitInputContainer,
                        border_color: FOUNDATIONS.color_accent_disabled_border_100,
                    },
                    digitShape: {
                        ...variantStateInputDigitPasswordDigitCommonStyles(FOUNDATIONS, FONT).digitShape,
                        font_size: FONT.font_paragraph_50.DESKTOP.font_size,
                        line_height: FONT.font_paragraph_50.DESKTOP.line_height,
                        color: FOUNDATIONS.color_accent_disabled_font_100,
                        font_weight: FONT_WEIGHT.font_regular,
                        [DeviceBreakpointsType.DESKTOP]: {
                            font_size: FONT.font_paragraph_50.TABLET.font_size,
                            line_height: FONT.font_paragraph_50.TABLET.line_height,
                        },
                        [DeviceBreakpointsType.MOBILE]: {
                            font_size: FONT.font_paragraph_50.MOBILE.font_size,
                            line_height: FONT.font_paragraph_50.MOBILE.line_height,
                        },
                    },
                },
                [InputDigitPasswordDigitStateType.DISABLED_FILLED_HIDE]: {
                    ...variantStateInputDigitPasswordDigitCommonStyles(FOUNDATIONS, FONT),
                    digitInputContainer: {
                        ...variantStateInputDigitPasswordDigitCommonStyles(FOUNDATIONS, FONT)
                            .digitInputContainer,
                        border_color: FOUNDATIONS.color_accent_disabled_border_100,
                    },
                    digitShape: {
                        ...variantStateInputDigitPasswordDigitCommonStyles(FOUNDATIONS, FONT).digitShape,
                        height: FOUNDATIONS.size_150,
                        width: FOUNDATIONS.size_150,
                        background_color: FOUNDATIONS.color_accent_disabled_icon_50,
                        border_radius: '50%',
                    },
                },
                [InputDigitPasswordDigitStateType.ERROR_EMPTY]: {
                    ...variantStateInputDigitPasswordDigitCommonStyles(FOUNDATIONS, FONT),
                    digitInputContainer: {
                        ...variantStateInputDigitPasswordDigitCommonStyles(FOUNDATIONS, FONT)
                            .digitInputContainer,
                        border_color: FOUNDATIONS.color_feedback_error_border_50,
                    },
                },
                [InputDigitPasswordDigitStateType.ERROR_FILLED]: {
                    ...variantStateInputDigitPasswordDigitCommonStyles(FOUNDATIONS, FONT),
                    digitInputContainer: {
                        ...variantStateInputDigitPasswordDigitCommonStyles(FOUNDATIONS, FONT)
                            .digitInputContainer,
                        border_color: FOUNDATIONS.color_feedback_error_border_50,
                    },
                    digitShape: {
                        ...variantStateInputDigitPasswordDigitCommonStyles(FOUNDATIONS, FONT).digitShape,
                        font_size: FONT.font_paragraph_50.DESKTOP.font_size,
                        line_height: FONT.font_paragraph_50.DESKTOP.line_height,
                        color: FOUNDATIONS.color_neutral_font_50,
                        font_weight: FONT_WEIGHT.font_regular,
                        [DeviceBreakpointsType.DESKTOP]: {
                            font_size: FONT.font_paragraph_50.TABLET.font_size,
                            line_height: FONT.font_paragraph_50.TABLET.line_height,
                        },
                        [DeviceBreakpointsType.MOBILE]: {
                            font_size: FONT.font_paragraph_50.MOBILE.font_size,
                            line_height: FONT.font_paragraph_50.MOBILE.line_height,
                        },
                    },
                },
                [InputDigitPasswordDigitStateType.ERROR_FILLED_HIDE]: {
                    ...variantStateInputDigitPasswordDigitCommonStyles(FOUNDATIONS, FONT),
                    digitInputContainer: {
                        ...variantStateInputDigitPasswordDigitCommonStyles(FOUNDATIONS, FONT)
                            .digitInputContainer,
                        border_color: FOUNDATIONS.color_feedback_error_border_50,
                    },
                    digitShape: {
                        ...variantStateInputDigitPasswordDigitCommonStyles(FOUNDATIONS, FONT).digitShape,
                        height: FOUNDATIONS.size_150,
                        width: FOUNDATIONS.size_150,
                        background_color: FOUNDATIONS.color_neutral_icon_50,
                        border_radius: '50%',
                    },
                },
                [InputDigitPasswordDigitStateType.ACTIVE]: {
                    ...variantStateInputDigitPasswordDigitCommonStyles(FOUNDATIONS, FONT),
                    digitInputContainer: {
                        ...variantStateInputDigitPasswordDigitCommonStyles(FOUNDATIONS, FONT)
                            .digitInputContainer,
                        border_width: FOUNDATIONS.border_50,
                        border_color: FOUNDATIONS.color_comp_forms_input_active_border,
                        outline: 'none',
                        outline_offset: 'unset',
                        box_shadow: 'none',
                    },
                    digitShape: {
                        ...variantStateInputDigitPasswordDigitCommonStyles(FOUNDATIONS, FONT).digitShape,
                        height: FOUNDATIONS.size_300,
                        width: '0.063rem',
                        background_color: FOUNDATIONS.color_secondary_border_100,
                    },
                },
                [InputDigitPasswordDigitStateType.ACTIVE_FILLED]: {
                    ...variantStateInputDigitPasswordDigitCommonStyles(FOUNDATIONS, FONT),
                    digitInputContainer: {
                        ...variantStateInputDigitPasswordDigitCommonStyles(FOUNDATIONS, FONT)
                            .digitInputContainer,
                        border_width: FOUNDATIONS.border_50,
                        border_color: FOUNDATIONS.color_comp_forms_input_active_border,
                        outline: 'none',
                        outline_offset: 'unset',
                        box_shadow: 'none',
                    },
                    digitShape: {
                        ...variantStateInputDigitPasswordDigitCommonStyles(FOUNDATIONS, FONT).digitShape,
                        font_size: FONT.font_paragraph_50.DESKTOP.font_size,
                        line_height: FONT.font_paragraph_50.DESKTOP.line_height,
                        color: FOUNDATIONS.color_comp_forms_input_filled_font,
                        font_weight: FONT_WEIGHT.font_regular,
                        [DeviceBreakpointsType.DESKTOP]: {
                            font_size: FONT.font_paragraph_50.TABLET.font_size,
                            line_height: FONT.font_paragraph_50.TABLET.line_height,
                        },
                        [DeviceBreakpointsType.MOBILE]: {
                            font_size: FONT.font_paragraph_50.MOBILE.font_size,
                            line_height: FONT.font_paragraph_50.MOBILE.line_height,
                        },
                        after: {
                            content: '',
                            position: 'absolute',
                            width: '0.063rem',
                            height: FOUNDATIONS.size_300,
                            top: '50%',
                            transform: 'translate(0%, -50%)',
                            bottom: '0',
                            background: FOUNDATIONS.color_secondary_border_100,
                            right: '-4px',
                        },
                    },
                },
                [InputDigitPasswordDigitStateType.ACTIVE_FILLED_HIDE]: {
                    ...variantStateInputDigitPasswordDigitCommonStyles(FOUNDATIONS, FONT),
                    digitInputContainer: {
                        ...variantStateInputDigitPasswordDigitCommonStyles(FOUNDATIONS, FONT)
                            .digitInputContainer,
                        border_width: FOUNDATIONS.border_50,
                        border_color: FOUNDATIONS.color_comp_forms_input_active_border,
                        outline: 'none',
                        outline_offset: 'unset',
                        box_shadow: 'none',
                    },
                    digitShape: {
                        ...variantStateInputDigitPasswordDigitCommonStyles(FOUNDATIONS, FONT).digitShape,
                        height: FOUNDATIONS.size_150,
                        width: FOUNDATIONS.size_150,
                        background_color: FOUNDATIONS.color_neutral_icon_50,
                        border_radius: '50%',
                        after: {
                            content: '',
                            position: 'absolute',
                            width: '0.063rem',
                            height: FOUNDATIONS.size_300,
                            top: '50%',
                            transform: 'translate(0%, -50%)',
                            bottom: '0',
                            background: FOUNDATIONS.color_secondary_border_100,
                            right: '-4px',
                        },
                    },
                },
            },
        },
    };
};
//# sourceMappingURL=default.js.map